var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1060.847,
    height: 880,
    viewBox: "0 0 1060.847 880",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-193.716 -100)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(136.494 -59.181)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.9,161.656c-9.429-1.571-19.691,9.945-23.976,14.755-11.442,12.841-13.831,27.78-14.755,34.12-14.58,100.064-21.869,150.1,8.3,173.367,28.671,22.116,81.079,16.185,91.294-3.689,3.979-7.742.652-15.841-4.611-31.354-9.727-28.671-15.46-58.552-23.976-87.606-19.445-66.34-17.813-97.184-32.276-99.594Z",
    transform: "translate(457.642 40.219)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.376,416.253l45.886,86.605c11.713,22.108,67.14,362.666,42.491,366.957l-106.767,3.542-44.3,2.325-45.534.656L24.287,880.082l63.4-443.541,157.69-20.288Z",
    transform: "translate(742.446 159.099)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.65,243.032l-91.294,3.689-7.377,30.431L83.993,295.088a29.286,29.286,0,0,0-10.41,27.294L83.846,386.89S64.481,433,113.356,462.508l48.875,79.306,169.678-17.521s15.677-1.844,4.611-12.91-24.9-65.474-24.9-65.474,1.844-23.976-4.611-30.431-1.96-23.054-1.96-23.054l-26.257-97.057a43.373,43.373,0,0,0-41.868-32.047H207.809Z",
    transform: "translate(670.207 78.263)",
    fill: "#f59e0b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.05,816.242,992.356,603.155a42.155,42.155,0,0,0,9.213-77.782L677.548,349.643a42.336,42.336,0,0,0-26.954-4.537L115.031,433.4A42.157,42.157,0,0,0,80.61,483.544L142.887,784.07A42.228,42.228,0,0,0,184.059,817.7,42.546,42.546,0,0,0,195.05,816.242Z",
    transform: "translate(-22.492 125.637)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.05,816.242,992.356,603.155a42.155,42.155,0,0,0,9.213-77.782L677.548,349.643a42.336,42.336,0,0,0-26.954-4.537L115.031,433.4A42.157,42.157,0,0,0,80.61,483.544L142.887,784.07A42.228,42.228,0,0,0,184.059,817.7,42.546,42.546,0,0,0,195.05,816.242Zm-79.3-378.5L651.31,349.447a37.924,37.924,0,0,1,24.141,4.063L999.471,529.24A37.755,37.755,0,0,1,991.22,598.9L193.915,811.991A37.757,37.757,0,0,1,147.2,783.176L84.918,482.65a37.755,37.755,0,0,1,30.829-44.912l-.358-2.171Z",
    transform: "translate(-22.492 125.637)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.361,508.7l71.1,179.42A35.01,35.01,0,0,0,286.4,708.324L809.028,528.5c28.857-9.929,32.081-49.453,5.214-63.927l-168.19-90.612a35.01,35.01,0,0,0-23.927-3.414L196.587,461.562A35.01,35.01,0,0,0,171.361,508.7Z",
    transform: "translate(37.726 137.41)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.509,
    cy: 14.755,
    rx: 29.509,
    ry: 14.755,
    transform: "translate(316.486 646.359)",
    fill: "#ff6884"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.509,
    cy: 14.755,
    rx: 29.509,
    ry: 14.755,
    transform: "translate(344.151 691.545)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 80.228,
    cy: 40.114,
    rx: 80.228,
    ry: 40.114,
    transform: "translate(452.044 605.322)",
    fill: "#f59e0b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.43,471.144a2.767,2.767,0,0,1-.924-5.375l58.543-20.749a2.767,2.767,0,1,1,1.848,5.216l-58.543,20.749a2.763,2.763,0,0,1-.924.159Z",
    transform: "translate(406.089 172.449)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.233,464.228a2.767,2.767,0,0,1-.924-5.375L331.852,438.1a2.767,2.767,0,0,1,1.848,5.216l-58.543,20.749a2.764,2.764,0,0,1-.924.159Z",
    transform: "translate(384.377 169.221)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.035,457.311a2.767,2.767,0,0,1-.924-5.375l58.543-20.749A2.767,2.767,0,0,1,342.5,436.4l-58.543,20.749a2.764,2.764,0,0,1-.924.159Z",
    transform: "translate(362.664 165.994)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.838,450.4a2.767,2.767,0,0,1-.924-5.375l58.543-20.749a2.767,2.767,0,1,1,1.848,5.216l-58.543,20.749a2.764,2.764,0,0,1-.924.159Z",
    transform: "translate(340.951 162.766)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.64,443.479a2.767,2.767,0,0,1-.924-5.375l58.543-20.749a2.767,2.767,0,1,1,1.848,5.216l-58.543,20.749a2.763,2.763,0,0,1-.924.159Z",
    transform: "translate(319.238 159.539)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.443,436.563a2.767,2.767,0,0,1-.924-5.375l58.543-20.749a2.767,2.767,0,0,1,1.848,5.216L310.367,436.4a2.764,2.764,0,0,1-.924.159Z",
    transform: "translate(297.526 156.311)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.245,429.646a2.767,2.767,0,0,1-.924-5.375l58.543-20.749a2.767,2.767,0,1,1,1.848,5.216l-58.543,20.749a2.763,2.763,0,0,1-.924.159Z",
    transform: "translate(275.813 153.084)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 75.618,
    cy: 75.618,
    rx: 75.618,
    ry: 75.618,
    transform: "translate(715.784 200.03)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.6,136.463c21.29-3.471,32.723-5.334,44.264-2.767,23.119,5.144,36.53,25.813,46.108,40.575,22.905,35.3,12.549,50.14,35.042,99.594,16.135,35.476,24.27,34.01,25.821,52.563,3.254,38.945-29.875,77.9-65.474,93.139-2.377,1.017-39.373,16.5-49.8,3.689-7.642-9.391,5.857-25.554,22.132-69.162,28.617-76.678,15.095-102.306,11.066-108.816-2.545-4.113-9.805-14.336-13.832-12.91-3.644,1.29-.49,10.646-3.689,18.443-8.571,20.89-60.666,25.528-101.438,9.222-12.024-4.809-19.4-7.76-24.9-15.677-18.651-26.863,3.615-83.157,38.731-99.594,7.989-3.739,17.314-5.259,35.964-8.3Z",
    transform: "translate(564.123 26.681)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.577,458.182c-18.391,9.328-28.485,26.379-22.547,38.082s25.659,13.626,44.055,4.292a51.607,51.607,0,0,0,18.733-15.594l77.425-40.509-19.784-35.928-74.227,43.749a51.611,51.611,0,0,0-23.655,5.908Z",
    transform: "translate(689.213 155.492)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.552,418.813c-19.373,7.066-31.431,22.79-26.932,35.118s23.848,16.592,43.227,9.521a51.608,51.608,0,0,0,20.46-13.246l81.707-30.975L493.661,381.2l-78.919,34.574A51.611,51.611,0,0,0,390.552,418.813Z",
    transform: "translate(77.127 142.74)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.252,275.1s15.677-32.276,51.641-7.377S229.619,395.906,229.619,395.906s44.264,38.731,19.365,52.563-203.8,94.061-203.8,94.061L0,511.177,160.457,429.1,68.287,359.942,56.252,275.1Z",
    transform: "translate(861.486 85.385)",
    fill: "#f59e0b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.5,285.175s-10.972-15.677-30.384,0-75.284,105.944-75.284,105.944L234.046,447.476l20.288,41.5L419.4,429.955l71.929-97.75L477.5,285.175Z",
    transform: "translate(283.473 94.678)",
    fill: "#f59e0b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.834,267.25c20.913,10.679,11.29,27.074,11.988,30.431,6.8,32.692-18.049,66.553-27.665,64.552-5.642-1.174-8.607-15.226-7.377-25.821,1.594-13.735-11.615-35.476-10.144-45.186,3.609-23.822-18.166-24.269-13.832-33.2,2.54-5.233,34.568,2.858,47.03,9.222Z",
    transform: "translate(493.897 84.477)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.4,507.56a2.006,2.006,0,0,1-.261-.016,2.2,2.2,0,0,1-1.926-2.444l4.96-41.879a2.2,2.2,0,0,1,2.448-1.925l78.773,9.473a2.2,2.2,0,0,1-.526,4.368l-76.585-9.21-4.7,39.69A2.2,2.2,0,0,1,346.4,507.56Z",
    transform: "translate(180.914 180.112)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(891.884 645.987)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.067,
    cy: 41.067,
    rx: 41.067,
    ry: 41.067,
    transform: "translate(0)",
    fill: "#f59e0b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.777,490.209l-13.2,23.213a2.217,2.217,0,0,1-3.8,0,76.806,76.806,0,0,0-21.411-25.886,2.278,2.278,0,0,1-.789-3.01,2.212,2.212,0,0,1,3.01-.789A81.645,81.645,0,0,1,139.578,511.2h-3.8l13.2-23.213c1.4-2.461,5.2-.247,3.8,2.221h0Z",
    transform: "translate(-93.052 -455.548)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetails);
export default __webpack_public_path__ + "static/media/details.a637c1d0a7dffa3e413a6f9f3035f1e1.svg";
export { ForwardRef as ReactComponent };